module.exports = __webpack_public_path__ + "img/MontereyBay.28acbc77.jpg";